import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const REVEAL_VIEWPORT = { once: true, margin: "-70px" };
const REVEAL_VISIBLE = { opacity: 1, y: 0 };
const MASK_VIEWPORT = { once: true, margin: "-40px" };
const MASK_INITIAL = { y: "115%" };
const MASK_LOAD_ANIM = { animate: { y: "0%" } };
const MASK_VIEW_ANIM = { whileInView: { y: "0%" }, viewport: MASK_VIEWPORT };

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={REVEAL_VISIBLE}
    viewport={REVEAL_VIEWPORT}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// line-by-line masked reveal. `animateOnLoad` plays immediately (hero).
export const MaskLines = ({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  animateOnLoad = false,
}) => {
  const anim = animateOnLoad ? MASK_LOAD_ANIM : MASK_VIEW_ANIM;
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span
          key={typeof line === "string" ? line : `line-${i}`}
          className="block overflow-hidden pb-[0.08em]"
        >
          <motion.span
            className={`block ${lineClassName}`}
            initial={MASK_INITIAL}
            {...anim}
            transition={{ duration: 1, delay: delay + i * 0.09, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
